export default "__VITE_ASSET__Cu1C0tQ8__"